<app-dialog
  [title]="'Edit Address'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Save',
      isDisabled: addressForm.invalid
    }
  ]"
  (action)="dialogAction($event)"
  (close)="dialogRef.close()"
>
  <mat-dialog-content>
    <form [formGroup]="addressForm" class="mt-4" autocomplete="off">  
      <div class="input-container mb-2">
        <label class="input-container_label" for=""
          >Warehouse Name:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Id"
          readonly
        />
      </div>
      <div class="input-container mb-2">
        <label class="input-container_label" for=""
          >Company Name:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Name"
        />
      </div>   
      <div class="input-container mb-2">
        <label class="input-container_label" for=""
          >Address Line #1:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Addressln1"
        />
      </div>
      <div class="input-container mb-2">
        <label class="input-container_label" for="">Address Line #2:</label>
        <input
          class="input-container_input"
          type="text"
          formControlName="Addressln2"
        />
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-container mb-2">
            <label class="input-container_label" for=""
              >City:<span class="input-container_asterisk">*</span></label
            >
            <input
              class="input-container_input"
              type="text"
              formControlName="City"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-container mb-2">
            <label class="input-container_label" for=""
              >State/Provinces:<span class="input-container_asterisk">*</span></label
            >
            <mat-form-field
              appearance="fill"
              class="mat-select-control mat-select-lg w-100"
            >
              <mat-select id="State" formControlName="State">
                <mat-option
                  [value]="state.abbreviation"
                  *ngFor="let state of states"
                >
                  {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
    
        </div>
      </div>
     <div class="row">
       <div class="col-md-6">
      <div class="input-container mb-2">
        <label class="input-container_label" for=""
          >Country:<span class="input-container_asterisk">*</span></label
        >
        <mat-form-field
          appearance="fill"
          class="mat-select-control mat-select-lg w-100"
        >
          <mat-select id="Country" formControlName="CountryCode">
            <mat-option [value]="'US'"> United States </mat-option>
            <mat-option [value]="'CA'"> Canada </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6">
      <div class="input-container mb-2">
        <label class="input-container_label"
          >Zip:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          numbersOnly
          formControlName="Postal"
        />
      </div>  
    </div>
    </div>   
    </form>
  </mat-dialog-content>
</app-dialog>
